import { washDetail, washFourDetail } from '@/utils/wash.js'
import { types } from '@/components/widgets/news_detail_three/elements.js'
const washData = (node) => {
  try {
    washDetail(node, 'news')
    if(node._type === types.four) {
      washFourDetail(node, 'news-detail-par')
    }
  } catch (err) {
    console.log('err--', err)
  }
}
export { washData }
